import DoublePrizeTicketCard from '../DoublePrizeTicketCard/index';
import TicketCard from '../../TicketCard/TicketCard';
import SinglePrizeTicketCard from '../SinglePrizeTicketCard';

const NewPrizeCard = (props) => {
  const isDoublePrize = props.raffles.length > 1;
  if (isDoublePrize) {
    return <DoublePrizeTicketCard {...props} theme='light' />;
  }
  // return <SinglePrizeTicketCard {...props} theme='light' />;
  return <TicketCard {...props} theme='light' />;
};

export default NewPrizeCard;
